import AddressInput from './address-input';

export default AddressInput;

export * from './address-input';
